import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { NgxMaskDirective } from 'ngx-mask';
import { AccountType } from '@app/shared/models/account-structure';
import { SplitTextPipe } from '../../../pipes/split-text.pipe';

@Component({
    selector: 'element-range-component',
    styleUrls: ['./element-range.component.less'],
    templateUrl: './element-range.component.html',
    standalone: true,
    imports: [
        NgFor,
        MatFormFieldModule,
        MatSelectModule,
        MatOptionModule,
        NgIf,
        MatButtonModule,
        MatIconModule,
        FormsModule,
        MatInputModule,
        NgxMaskDirective,
        SplitTextPipe,
    ],
})
export class FieldElementRangeComponent extends FieldType<FormlyFieldConfig> implements OnInit {
	assetFundElementIndex: any;
	expenseFundElementIndex: any;
	liabilityFundElementIndex: any;
	reserveFundElementIndex: any;
	revenueFundElementIndex: any;
	accountTypes: AccountType[];
	budgetSetup: any;
	fundOnly: any;
	queryOptions = [
		{
			displayName: 'is > or =',
			query: 'greaterthanorequal',
		},
		{
			displayName: 'is < or =',
			query: 'lessthanorequal',
		},
		{
			displayName: 'is >',
			query: 'greaterthan',
		},
		{
			displayName: 'is <',
			query: 'lessthan',
		},
		{
			displayName: '=',
			query: 'equal',
		},
	];

	ngOnInit(): void {
		this.value = [
			{
				type: null,
				queries: [],
			},
		];
	}

	removeQuery = (query, index: number) => {
		const queryIndex = (this.value[index].queries as any[]).findIndex((el) => el.AccountTypeId === query.AccountTypeId);
		this.value[index].queries.splice(queryIndex, 1);
	};

	addQuery = (index: number) => {
		const element = this.value[index];
		element.queries.push({ AccountTypeId: element.type.Id });
	};

	removeFilter = (index) => {
		this.value.splice(index, 1);
		// Only include 'All' in the list of Account Types when there is only one filter.
		if (this.value.length === 1) {
			this.props.accountTypes.unshift({
				Id: 0,
				Description: 'All',
			} as AccountType);
		}
	};

	addFilter = () => {
		// Only include 'All' in the list of Account Types when there is only one filter.
		const allIdx = this.props.accountTypes.findIndex((item) => item.Id === 0);
		if (allIdx !== -1) {
			this.props.accountTypes.splice(allIdx, 1);
		}
		this.value.push({
			type: null,
			queries: [{}],
		});
	};

	changeSelection(event: any, index: number) {
		this.value[index].type = event;
		this.value[index].queries = [{ AccountTypeId: event.Id, FundElementIndex: event.FundElementIndex }];
	}
}
